import {
  GET_SURVEY,
  GET_USER_PREFERENCE,
  POST_SURVEY,
  SURVEY_ERROR,
  SURVEY_FETCHING,
  PROMISE_PENDING,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
} from '../constants';
import error from "../utils/error";

const initialState = {
  survey: {
    option: [],
  },
  userSurvey: {
    isFetch: false,
    isSubmit: false,
    success: null,
    error: null,
    data: []
  },
  preferences: {
    data: [],
    isFetch: false,
    success: null,
    error: null,
  },
  isFetch: false,
  isSubmit: false,
  success: null,
  error: null,
};

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_SURVEY}${PROMISE_PENDING}`: {
      return {
        ...state,
        isFetch: true,
        error: null,
      };
    }
    case `${GET_SURVEY}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        survey: { ...data, message, status_code },
        error: null,
        isFetch: false,
        error: null,
      };
    }
    case `${GET_SURVEY}${PROMISE_REJECTED}`: {
      return {
        ...state,
        ...error(action.payload), isFetch: false
      };
    }
    case `${POST_SURVEY}${PROMISE_PENDING}`: {
      return {
        ...state,
        userSurvey: { ...state.userSurvey, isSubmit: true },
      };
    }
    case `${POST_SURVEY}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        userSurvey: { ...state.userSurvey, data: [...data], message, status_code, isSubmit: false, error: null },
      };
    }
    case `${POST_SURVEY}${PROMISE_REJECTED}`: {
      return {
        ...state,
        userSurvey: { ...state.userSurvey, isSubmit: false, ...error(action.payload)},
      };
    }
    case `${GET_USER_PREFERENCE}${PROMISE_PENDING}`: {
      return {
        ...state,
        preferences: { ...state.preferences, isFetch: true }
      };
    }
    case `${GET_USER_PREFERENCE}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return {
        ...state,
        preferences: { ...state.preferences, data, status_code, message, isFetch: false, error: null}
      };
    }
    case `${GET_USER_PREFERENCE}${PROMISE_REJECTED}`: {
      return {
        ...state,
        preferences: { ...state.preferences, isFetch: false, ...error(action.payload) }
      };
    }
    default:
      return state;
  }
};

export default surveyReducer;
